import React from 'react';
export var ResourceSummaryItem = function ResourceSummaryItem(properties) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline-flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: properties.color ? {
      backgroundColor: properties.color,
      display: 'inline-flex',
      width: '3px',
      height: '26px',
      margin: '0 8px'
    } : {
      marginLeft: 8
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '12px',
      minWidth: '48px',
      lineHeight: '20px',
      color: '#707275'
    }
  }, properties.data[properties.colorField]), /*#__PURE__*/React.createElement("span", {
    style: {
      lineHeight: '22px',
      color: '#181A1D',
      fontWeight: '500'
    }
  }, properties.data[properties.angleField])));
};